import { GEAR } from '@/utils/constants';
import { useTranslations } from 'next-intl';
import { GearIcon } from '@/components/icons/Gear';
import { Chip } from '@/components/ui/Chip/Chip';

interface Props {
  gear: GEAR;
  isActive: boolean;
  isDisabled?: boolean;
  onClick: () => void;
}

export const GearChip = ({ gear, isActive, isDisabled = false, onClick }: Props) => {
  const t = useTranslations('gear');

  return (
    <Chip
      icon={<GearIcon gear={gear} size={20} inheritColor />}
      label={t(gear)}
      isActive={isActive}
      isDisabled={isDisabled}
      onClick={onClick}
    />
  );
};
